// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Formatting = t.struct({
    dateFields: t.list(t.String, 'DateField')
});

export const getDefaultState = () =>
    new Formatting({
        dateFields: [
            'intervalBeginDate',
            'intervalEndDate',
            'completionDate',
            'planStartDate',
            'planEndDate'
        ]
    });

export default Formatting;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/state/formatting.js